<ul class="mbsc-cloak sv-featured">
  <li>
    <div>
      {#if fullScreenClass === ''}
      <img class="mbsc-media-fluid" src="{featured}" alt="D-NS Studio">
      {:else}
      <div class="mbsc-media-fluid {fullScreenClass}" style="background-image: url({featured});">&nbsp;</div>
      {/if}
      <h3 class="mbsc-col-12">{title}</h3>
      <h4 class="mbsc-col-9">{@html subtitle}</h4>
      {#if actionCommand}
      <button class="mbsc-button mbsc-btn-light" on:click={actionCommand}>{actionLabel}</button>
      {/if}
    </div>
  </li>
</ul>

<style src='style.scss'>

</style>

<script>
  import { onMount, afterUpdate, createEventDispatcher } from 'svelte';

  const DEBUG = document.location.protocol === 'http:' ? true : false;

  const dispatch = createEventDispatcher();

  export let title = 'Bienvenido a D-NS Studio';
  export let subtitle = 'Con tu registro tendrás acceso a todas las clases durante <span>7 días.</span>.';
  export let actionLabel = '¡Regístrate hoy!';
  export let actionCommand = null;
  export let featured = '/images/featured-tv.jpg';
  export let fullScreenClass = '';

  afterUpdate(() => {});

  onMount(async () =>{
    mobiscroll.scrollview('.sv-featured', {
      layout: 1,
      paging: true,
    });
  });
</script>
